//export const APIURL = "https://qa_service.dooddo.com/api"
 export const APIURL = "https://service.dooddo.com/api"
export const AUTH_CREDENTIALS_NAME = "THOKEN_DOODDO_ADMIN"
export const URL_CONSULTA_COTIZACION = "https://www.dooddo.com/micotizacion"
export const AUTH_USERS_NAME = "user"
export const SITE_DOMAIN = "https://www.dooddo.com"
export const IS_DOODDO = true
